import { MealTiersRepository } from '../../domain/repositories/MealTiersRepository'
import { MealTiersModel } from '../models/MealTiersModel'
import { MealTiersMiniModel } from '../models/MealTiersMiniModel'
import { MealTiersFilterModel } from '../models/MealTiersFilterModel'
import { MealTiersService, type PostMealTierAdminRequest } from '@/backend/market'
import type { CreateUpdateMealTierEntity } from '../../domain/entities/CreateUpdateMealTierEntity'
import type { MealTiersFilterEntity } from '../../domain/entities/MealTiersFilterEntity'
import type { MealTiersEntity } from '../../domain/entities/MealTiersEntity'
import type { MealTiersResponseEntity } from '../../domain/entities/MealTiersResponseEntity'
import { CreateUpdateMealTierModel } from '../models/CreateUpdateMealTierModel'

export class MealTiersRepositoryImpl implements MealTiersRepository {
  async getMealTiers(filterData: MealTiersFilterEntity): Promise<MealTiersResponseEntity | { error: true }> {
     try {
        const mealTiersFilterModel = new MealTiersFilterModel(filterData)
        const response = await MealTiersService.getMealTiersAdmin(mealTiersFilterModel)
        const mealTierModels = response?.items?.map((mealTier) => new MealTiersMiniModel(mealTier)) ?? []
        return {
          ...response,
          items: mealTierModels
        }
      } catch {
        return { error: true }
      }
    }

  async getMealTierById(id: number): Promise<MealTiersEntity | { error: true }> {
    try {
      const response = await MealTiersService.getMealTierAdmin({ id })
      const mealTierModel = new MealTiersModel(response)
      return mealTierModel
    } catch {
      return { error: true }
    }
  }

  async createMealTier(data: CreateUpdateMealTierEntity): Promise<{ success: true } | { error: true }> {
    const createUpdateMealTierModel = new CreateUpdateMealTierModel(data)
    try {
     
       await MealTiersService.postMealTierAdmin({
        requestBody: createUpdateMealTierModel as PostMealTierAdminRequest
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async updateMealTier(
    id: number,
    data: CreateUpdateMealTierEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      const requestBody = {
        icon: data.icon,
        translations: data.translations || []
      }
      await MealTiersService.putMealTierAdmin({
        id,
        requestBody
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async deleteMealTier(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await MealTiersService.deleteMealTierAdmin({ id })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}